import { Step, StepLabel, Stepper, Box } from "@mui/material";
import { capitalCase } from "change-case";
import { JobStatus } from "generated/graphql";
import useUpdateJobStatus from "hooks/jobs/useUpdateJobStatus";
import MDTypography from "components/MDTypography";

export default function JobStatusStepper({
  status,
  jobId,
}: {
  status: JobStatus;
  jobId: string;
}) {

  const jobStatus: JobStatus[] = [
    JobStatus.TO_BE_SCHEDULED,
    JobStatus.SCHEDULED,
    JobStatus.IN_PROGRESS,
    JobStatus.WORK_COMPLETE,
    JobStatus.JOB_COSTING,
    JobStatus.READY_TO_BILL,
    JobStatus.COMPLETE,
  ];
  const [updateJobStatus, { loading }] = useUpdateJobStatus();

  const activeStep = jobStatus.indexOf(status);

  const handleStatusChange = (newStatus: string) => {
    if (newStatus === status || loading) return;

    updateJobStatus({
      variables: {
        id: jobId,
        status: newStatus as JobStatus,
      },
    });
  };

  return (
    <>
      <Box textAlign="center" mb={1}>
        <MDTypography variant="caption" color="text.secondary">
          Click to change job status
        </MDTypography>
      </Box>
      <Stepper nonLinear activeStep={activeStep} alternativeLabel>
        {jobStatus.map((label, index) => {
          const isClickable = index !== activeStep;
          const stepProps = isClickable
            ? {
                sx: {
                  cursor: "pointer !important",
                  "&:hover": {
                    "& .MuiStepLabel-label": {
                      color: "#fff",
                    },
                  },
                },
              }
            : {};

          return (
            <Step
              key={label}
              {...stepProps}
              onClick={() => isClickable && handleStatusChange(label)}
            >
              <StepLabel>{label ? capitalCase(label) : ""}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </>
  );
}
